import { render, staticRenderFns } from "./MemberCompanyRoleTableCell.vue?vue&type=template&id=4a1ae99e&scoped=true"
import script from "./MemberCompanyRoleTableCell.vue?vue&type=script&lang=ts"
export * from "./MemberCompanyRoleTableCell.vue?vue&type=script&lang=ts"
import style0 from "./MemberCompanyRoleTableCell.vue?vue&type=style&index=0&id=4a1ae99e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ae99e",
  null
  
)

export default component.exports